var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pageRoot" }, [
    _vm.error
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("ScaleLoader"), _vm._v(" Loading…")],
          1
        )
      : _vm.projects
      ? _c(
          "div",
          {},
          [
            _c("vue-good-table", {
              attrs: { columns: _vm.columns, rows: _vm.projects },
              on: { "on-row-click": _vm.rowClick }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "buttonRow" }, [
              _c("input", {
                attrs: { type: "button", value: "Add Project" },
                on: { click: _vm.addProject }
              })
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }